import { Component } from 'react'
import { ServiceDataModel } from '../OrderModels'
import ServiceType from "../../../api/Administration/Model/ServiceType"
import Service from "../../../api/Administration/Model/Service"
import AccountService from "../../../api/Administration/Model/AccountService"
import { OrderDefault } from '../../../api/Administration/OrderDefaults'


export interface SelectServiceProps {
  disabled: boolean,
  open?: boolean,
  isDot?: boolean,
  selectedTestCode?: string,
  labAccountNumber?: string,
  panelId?: number,
  canAddDOT: boolean,
  canAddNonDOT: boolean,
  orderableServiceType: ServiceType,
  orderableServices: Service[],
  orderableAccountServices: AccountService[],
  defaults?: OrderDefault[],
  marketplaceServicesCount: number,
  notMarketplaceServicesCount: number,
  denyAddService: boolean
  regulatoryModeID?: number
  employeeCategoryID?: number
  onAdd: (data: ServiceDataModel) => void
}

export interface SelectServiceState extends ServiceDataModel { 

}

export default class SelectService<P extends SelectServiceProps, S extends SelectServiceState> extends Component<P, S> {
  isAllServicesDisabled: boolean = true;
  static getDerivedStateFromProps(props: SelectServiceProps, state: SelectServiceState) {
    let shouldResetDOT = !props.canAddDOT && state.isDOT === true
    shouldResetDOT = shouldResetDOT || (!props.canAddNonDOT && state.isDOT === false)
    if (shouldResetDOT) {
      return {...state, isDOT: undefined}
    }
    return null
  }
}
